import useViewsSelector from "views/stores/useViewsSelector";
import { selectActiveViewState } from "views/logic/slices/viewSelectors";
const useActiveViewState = () => useViewsSelector(selectActiveViewState);
export default useActiveViewState;
